<script>
import { mapState } from 'vuex';
import TwNavigation from './components/TwNavigation';
import TwMainToolbar from './components/TwMainToolbar';
import TwContentWrapper from './components/TwContentWrapper';

export default {
  name: 'App',
  components: {
    TwNavigation,
    TwMainToolbar,
    TwContentWrapper,
  },
  data() {
    return {
      snackbarShow: false,
    };
  },
  computed: {
    ...mapState({
      snackbarText: state => state.app.snackbar.text,
      snackbarWatch: state => state.app.snackbar.show,
      snackbarColor: state => state.app.snackbar.color,
    }),
  },
  mounted() {
    this.$Progress.finish();
  },
  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },
  watch: {
    snackbarWatch() {
      this.snackbarShow = true;
    },
  },
};
</script>

<template>
  <div id="app">
    <v-app>
      <v-responsive id="app-wrapper" min-width="1280px">
        <tw-navigation/>
        <tw-main-toolbar/>
        <tw-content-wrapper>
          <router-view/>
        </tw-content-wrapper>
      </v-responsive>
    </v-app>
    <vue-progress-bar></vue-progress-bar>
    <v-snackbar v-model="snackbarShow" :color="snackbarColor">
      <v-flex xs12 text-xs-center body-1>
        {{ snackbarText }}
      </v-flex>
    </v-snackbar>
  </div>
</template>

<style lang="scss">
  .v-toolbar__content {
    min-width: 1280px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue